import React from 'react';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import styles from './viewImage.scss';
import MoreMenu from 'jd-library/MoreMenu';
import withRipple from 'jd-library/withRipple';
import FormFeedBack from 'jd-library/FormFeedBack';
import ActionDialog from 'jd-library/ActionDialog';
import historyHandler from 'jd-library/historyHandler';
import FileSelector from '../FileSelector';
import { uploadMultipleFile, getAddImageDivCount } from '../productImageUtils';
import Image from '../Image/ImageLazyWrapper';
import VideoPlayer from '../Video/VideoPlayerWrapper';
import ImageViewUpload, { AddVideoDiv } from '../product-image/ImageViewUpload';
import MobileFilterRipple from '../Filter/MobileFilterRipple';
import { toggleUploadOptions } from '../../actions/upload-options';
import { updateEditProductDetail, toggleEditOptions } from '../../actions/products';
import { openGallery, onImageUploadFromAppSuccess } from '../Utills';
import UploadImageOptions from './uploadImageOptions';
import ScrollIndicators from './ScrollIndicators';
import DetailPopover from './DetailPopover';
import toastMessageActions from 'jd-library/toastMessageActions';
import SortItemSlider from '../sort-item/SortitemSlider';

class ViewImage extends React.Component {

	addImageIcon = 'icon-AddNewImage';
	showColorImage = this.props.showColorImage != undefined ? this.props.showColorImage : false;

	getImageUrls = (imageUrlArr, videoUrlArr) => {
		let items = [...imageUrlArr, ...videoUrlArr].map((cur, index) => {
			return cur;
		});
		return items;
	};

	getModalTitle = (str) => {
		return <span style={{ fontWeight: '600' }}>{str}</span>
	}
	checkForOptions = () => {
		if (this.props.showOptions) {
			this.setState({ showUploadSlider: true });
		} else {
			this.fileSelector.triggerClick(true);
		}
	}
	checkForOptionsBusiness = (e, forVideo) => {
		let self = this;
		if (this.props.showOptions) {
			this.setState({ showUploadSlider: true });
		} else {
			if (!(window.jdInterface && !window.jdInterface.isIOSApp && !window.jdInterface.openNativeFileChooser)) {
				if (this.props.isSourceB2B) {
					this.props.toggleUploadOptions({
						show: true,
						type: forVideo ? 'video' : 'image',
						data: {
							productId: this.props.productId,
							ignoreSave: this.props.ignoreSave,
							imageUrlArr: this.props.imageUrlArr,
							isAddEditPage: this.props.isAddEditPage
						},
						style: {
							position: 'absolute',
							left: e.clientX - 215,
							top: e.clientY - document.body.getBoundingClientRect().top - 55
						},
						containerInfo: {
							element: e.currentTarget || e.target,
							pos: this.useBottomPostion ? 'bottom' : 'left'
						},
						updateProductImage: this.props.updateProductImage,
						isAddEditPage: this.props.isAddEditPage,
						showAIoption: this.props.showAIoption,
						keywordId: this.props.keywordId,
						customHandler: this.props.hasCustomHandler ? this.onFileUpload : null,
						updateError: this.props.updateError,
						...this.props.uploadOptionProps
					});
					this.useBottomPostion = false;
				} else {
					this.fileSelector.triggerClick(true);
				}
			} else {
				let onImageUploadFromAppCB = function (res) {
					let onUploadSuccessCB = function () {
						self.setState({
							showSaveButton: true
						});
					}
					onImageUploadFromAppSuccess(res, self.props, self.props.productId, onUploadSuccessCB);
				};
				openGallery({ index: 0, callback: onImageUploadFromAppCB });
			}
		}
	}
	checkForOptions = (e, forVideo) => {
		if (this.props.isReadOnly) {
			return;
		}
		if (this.props.b2bGenio && this.props.checkLoggedIn) {
			let self = this;
			this.props.checkLoggedIn({
				cb: () => {
					self.checkForOptionsBusiness(e, forVideo);
				},
				history: self.props.routerHistory
			});
		} else {
			this.checkForOptionsBusiness(e, forVideo);
		}
	}

	actionModalRef = React.createRef();
	selImageIndex = this.props.selImageIndex || 0;
	dontShowPrimary = this.props.dontShowPrimaryTag || false;
	sliderCounter = 0;
   	firstImageTileLeftPosition = 0;
	state = {
		loadingImageTitle: 0,
		showPrimaryModal: false,
		selectedImageIndex: this.selImageIndex,
		defaultImageIndex: 0,
		showSaveButton: false,
		loadedImages: [Math.max(this.selImageIndex - 1, 0), this.selImageIndex, this.selImageIndex + 1],
		dontShowPrimaryTag: this.dontShowPrimary,
		modalOptions: {
			onHidden: () => {
				this.setState({ showPrimaryModal: false });
			},
			settings: {
				modalId: 'editProductModal',
				class: styles['edit-product-modal']
			},
			clearAllScrollLocks: false,
			btnArray: [{
				variant: 'secondary',
				children: 'Cancel',
				clickHandler: () => {
					historyHandler.closeCurrent();
				}
			}, {
				variant: 'primary',
				children: 'Yes',
				clickHandler: () => {
					this.setDefaultImage();
					// this.actionModalRef.current.modal('hide');
					historyHandler.closeCurrent();
				}
			}
			],
			title: this.getModalTitle('Set as Primary Image'),
			content: 'Are you sure you want to set as primary image?'
		},
		imageUrlList: [...this.props.imageUrlArr]
	};

	thumbnailHolder = React.createRef();
	focusTimer = null;
	componentDidUpdate = prevProps => {
		const imageUrlsUpdated = prevProps.imageUrlArr.length < this.props.imageUrlArr.length;
		const videoUrlsUpdated = prevProps.videoUrlArr.length < this.props.videoUrlArr.length;
		const imageUrlListUpdated = this.state.imageUrlList.length != this.props.imageUrlArr.length;
		if (
			this.focusTimer === null &&
			(imageUrlsUpdated || videoUrlsUpdated)
		) {
			let focusIndex = videoUrlsUpdated ? prevProps.imageUrlArr.length + 1 : prevProps.imageUrlArr.length;
			if (typeof this.restoreIndex === 'number') {
				focusIndex = this.restoreIndex;
				delete this.restoreIndex
			}
			this.focusTimer = setTimeout(() => {
				this.focusTimer = null;
				this.onImageClick(focusIndex, true);
			}, 200);
		}
		if (imageUrlListUpdated) {
			this.setState({imageUrlList : [...this.props.imageUrlArr]});
		}
	};
	componentDidMount() {
		if (this.slickSlider) {
			this.slickSlider.slickGoTo(this.state.selectedImageIndex);
			this.setScrollToSelectedThumbnai();
		}
	}
	onImageClick(index, setFocus) {
		this.setState(
			{
				selectedImageIndex: index,
				loadedImages: this.getImagesToLoad(index)
			},
			() => {
				setFocus && this.setScrollToSelectedThumbnai();
			}
		);
		this.slickSlider.slickGoTo(index);
	}

	setScrollToSelectedThumbnai() {
		const thumbnailHolder = this.thumbnailHolder;
		if (thumbnailHolder && thumbnailHolder.current) {
			const selectedIndex = this.state.selectedImageIndex;
			const thumbnaiWidth = this.props.ignoreSave ? 80 : 90;
			thumbnailHolder.current.scrollLeft = selectedIndex * thumbnaiWidth;
		}
	}

	deleteVideoBusiness = (videoId) => {
		this.setState({
			showSaveButton: true
		});
		let reviewStatus = "";
		let user = this.props.session.user || {};
		user = user.loggedUser || {};
		if(user.userType == "JDEMPLOYEE") {
			reviewStatus = "APPROVAL_PENDING";
		}
		this.onImageClick(this.props.imageUrlArr.length - 1, true);
		this.props.deleteProductVideo({
			productId: this.props.productId,
			videoId,
			reviewStatus,
			ignoreSave: this.props.ignoreSave,
			isAddEditPage: this.props.isAddEditPage,
			undoInfo: {
				type: 'video',
				data: {
					videoId
				},
				productId: this.props.productId
			}
		});
	}

	deleteVideo = (videoId) => {
		if(this.props.showUndoToast || true){
			const prevSelImage = this.state.selectedImageIndex;
			this.props.showToastMessage({
				showToastMessage: true,
				message: 'Video Removed',
				duration: 5000,
				type: 'info'
				// hasUndo: true,
				// onUndoClick: () => {
				// 	console.log('On Undo Clicked Here');
				// 	this.props.restoreProductData();
				// 	this.restoreIndex = prevSelImage;
				// }
			})
		}
		if (this.props.b2bGenio && this.props.checkLoggedIn) {
			let self = this;
			this.props.checkLoggedIn({
				cb: () => {
					self.deleteVideoBusiness(videoId);
				},
				history: self.props.routerHistory
			});
		} else {
			this.deleteVideoBusiness(videoId);
		}
	}

	deleteImageBusiness = (customIndex,ignoreToast = false,forCropper = false) => {
		if (this.props.showUndoToast && !ignoreToast) {
			const prevSelImage = this.state.selectedImageIndex;
			this.props.showLibraryToastMessage({
				showToastMessage: true,
				message: 'Image Removed',
				duration: 5000,
				hasUndo: true,
				type: 'info',
				bottom: this.props.session.hasGlassFooter ? '80px' : '0px',
				onUndoClick: () => {
					console.log('On Undo Clicked Here');
					this.restoreIndex = prevSelImage;
					this.props.restoreProductData();
				}
			})
		}
		//this.slickSlider.slickGoTo(0);
		let imageUrls = [...this.props.imageUrlArr];
		// if(imageUrls.length < 2) {
		// 	this.props.showLibraryToastMessage({
		// 		showToastMessage: true,
		// 		message: `At least one image is Required for saving the Product`,
		// 		duration: 5000,
		// 		type: 'info'
		// 	});
		// 	return;
		// }
		const currentIndex = typeof customIndex == 'number' ? customIndex : this.state.selectedImageIndex;
		this.setState({
			showSaveButton: true
		});
		if(forCropper) {
			imageUrls[currentIndex] = imageUrls.pop();
		}else {
			imageUrls.splice(currentIndex, 1);
		}
		if (imageUrls.length > currentIndex) {
			this.onImageClick(currentIndex, true);
		} else if (imageUrls.length == 1) {
			this.onImageClick(0, true);
		}
		let reviewStatus = "";
		let user = this.props.session.user || {};
		user = user.loggedUser || {};
		if(user.userType == "JDEMPLOYEE") {
			reviewStatus = "APPROVAL_PENDING";
		}
		this.props.deleteProductImage({
			productId: this.props.productId,
			supplierId: this.props.session.supplierId,
			imageUrlArr: imageUrls,
			ignoreSave: this.props.ignoreSave,
			reviewStatus,
			isAddEditPage: this.props.isAddEditPage,
			undoInfo: {
				type: 'image',
				index: currentIndex,
				productId: this.props.productId,
				isAddEditPage: this.props.isAddEditPage,
				data: { ...this.props.imageUrlArr[currentIndex] }
			}
		});
		if(forCropper){
			setTimeout(() => {
				if (imageUrls.length > currentIndex) {
					this.onImageClick(currentIndex, true);
				} else if (imageUrls.length == 1) {
					this.onImageClick(0, true);
				}	
			}, 500);
		}
	}

	deleteImage() {
		if (this.props.b2bGenio && this.props.checkLoggedIn) {
			let self = this;
			this.props.checkLoggedIn({
				cb: () => {
					self.deleteImageBusiness();
				},
				history: self.props.routerHistory
			});
		} else {
			this.deleteImageBusiness();
		}
	}
	onFileUpload = (event, props) => {
		props = props || this.props;
		const noOfFilesToUpload = event.target.files.length;
		this.setState({
			showSaveButton: true,
			loadingImageTitle: noOfFilesToUpload
		});
		uploadMultipleFile({
			data: event.target.files,
			productId: props.productId,
			updateImage: payload => {
				let editProductId = props.productId;
				if (editProductId === 'ADD_PRODUCT' && payload.productId) {
					editProductId = payload.productId;
				}
				this.setState({ loadingImageTitle: payload.noOfFilesToUpload > this.state.loadingImageTitle ? --this.state.loadingImageTitle : --payload.noOfFilesToUpload });
				props.updateProductImage({
					imageUrl: payload,
					editProductId,
					imgIndex: payload.imgIndex,
					noOfFilesToUpload: payload.noOfFilesToUpload,
					ignoreSave: this.props.ignoreSave,
					source: this.props.session.source,
					imgSuccessMsg: 'Image Uploaded Successfully'
				});
				this.onImageClick(this.props.imageUrlArr.length -1);
			},
			imageUrlArr: props.imageUrlArr,
			showToastMessage: props.showToastMessage,
			imgUploadUrl: props.imgUploadUrl,
			imgSuccessMsg: 'Image Uploaded Successfully',
			onErrorCB: () => {
				this.setState({ loadingImageTitle: --this.state.loadingImageTitle})
			}
		});
	};
	defaultBusiness = () => {
		this.setState({
			showSaveButton: true
		});
		let imageUrls = [...this.props.imageUrlArr];
		/* [imageUrls[0], imageUrls[this.state.selectedImageIndex]] = [
			imageUrls[this.state.selectedImageIndex],
			imageUrls[0]
		]; */
		//refs#278343
		let newDefaultImage = imageUrls.splice(this.state.selectedImageIndex, 1);
		if (newDefaultImage[0]) {
			imageUrls.unshift(newDefaultImage[0]);
		}
		/*this.setState({
			selectedImageIndex: 0
		});
		this.slickSlider.slickGoTo(0);*/
		this.onImageClick(0, true);
		this.props.deleteProductImage({
			productId: this.props.productId,
			supplierId: this.props.session.supplierId,
			imageUrlArr: imageUrls,
			ignoreSave: this.props.ignoreSave,
			from: this.props.from,
			isAddEditPage: this.props.isAddEditPage,
		});
		this.setState({imageUrlList : [...imageUrls]});
		this.props.showLibraryToastMessage({
			showToastMessage: true,
			message: 'Set as Primary Image',
			duration: 5000,
			type: 'info',
		})
	}
	setDefaultImage = () => {
		if (this.props.b2bGenio && this.props.checkLoggedIn) {
			let self = this;
			this.props.checkLoggedIn({
				cb: () => {
					self.defaultBusiness();
				},
				history: self.props.routerHistory
			});
		} else {
			this.defaultBusiness();
		}
	}

	getImagesToLoad = (index) => {
		let imagesToLoad = [index - 1, index, index + 1];
		let loadedImages = [...this.state.loadedImages];
		imagesToLoad.map((cur) => {
			if (!loadedImages.includes(cur)) {
				loadedImages.push(cur);
			}
		});
		return loadedImages;
	}

	getPath(url, isLarge) {
		if (!url) {
			return;
		} else if (url.indexOf('base64') != -1) {
			return url;
		}
		if (isLarge) {
			return url.replace(/(\.jpg|\.jpeg|\.png)/g, '$1?fit=around|619:498');
		}
		return url.replace(/(\.jpg|\.jpeg|\.png)/g, '$1?fit=around|235:235');
	}

	onImageAdd = () => {
		this.setState({
			showSaveButton: true
		});
	}

	moveOption = (index,nextIndex) => {
		const imageList = [...this.state.imageUrlList];
		const element = imageList[index];
		imageList.splice(index,1);
		imageList.splice(nextIndex,0,element);
		this.setState({imageUrlList: imageList});
	}

	updateImagePosition = () =>{
		this.props.updateEditProductDetail([{
			key: 'imageUrlArr',
			value: [...this.state.imageUrlList]
		}])
		this.setState({showSortItemSlider : false})
	}

	render() {
		const errorMessage =
			!this.props.imageUrlArr.length && this.props.errorMessage;
		const errorIndex = this.props.videoUrlArr.length && errorMessage ? 1 : 0;
		const isTemplate = this.props.isTemplate;
		const isTempProd = this.props.isTempProd;
		let imageUrls = this.getImageUrls(this.props.imageUrlArr, this.props.videoUrlArr);
		if (this.state.loadingImageTitle) {
			for (var i = 0; i < this.state.loadingImageTitle; i++) {
				imageUrls.push({ "retainRandomColor": true });
			}
		}
		const selectedMedia = imageUrls[this.state.selectedImageIndex] || {};
		const floatingBtnArr = this.props.session.isReadOnly 
			? [] 
			: isTemplate
				? []
				: [
				{
					key: 'deleteImage',
					// show: this.props.imageUrlArr.length == 1,
					show: (isTemplate || this.props.isReadOnly) || (this.props.imageUrlArr[this.state.selectedImageIndex]?.isLabelProof) ? false : true,
					iconClass: 'icon-trash',
					info: 'Delete',
					onClick: () => {
						if (selectedMedia.isVideo) {
							this.deleteVideo(selectedMedia.videoId);
						} else {
							this.deleteImage();
						}
					}
				},
				{
					key: 'moreOption',
					// show: this.props.imageUrlArr.length > 1,
					show: false,
					iconClass: 'icon-moreNew'
				},
				{
					key: 'addImage',
					iconClass: this.addImageIcon,
					show: !isTemplate && this.props.imageUrlArr.length < 40 && !this.props.uploadSingleImage && !this.props.isReadOnly && !this.props.showMax,
					info: 'Upload Image',
					onClick: (e) => {
						this.checkForOptions(e);
					}
				},
				{
					key: 'addVideo',
					iconClass: 'icon-VideoOutline',
					show: !this.props.videoUrlIds.length && this.props.isSourceB2B && !this.props.isReadOnly && (this.props?.showUpload === 0 || this.props?.showUpload === -1 || this.props?.session?.viaOmni),
					info: 'Upload Video',
					onClick: (e) => {
						this.checkForOptions(e, true) //forVideo
					}
				},
				{
					key: 'primaryImage',
					show: this.state.selectedImageIndex != this.state.defaultImageIndex && !isTemplate && !this.props.uploadSingleImage && !selectedMedia.isVideo && !this.props.isReadOnly,
					iconClass: 'icon-starOutline',
					info: 'Set as Primary',
					onClick: () => {
						this.setDefaultImage();
						// if(this.props.showPrimaryModal) {
						// 	this.setDefaultImage();
						// } else {
						// 	this.setState({showPrimaryModal: true});
						// }
						// this.actionModalRef.current.modal('show');
					}
				},
				{
					key: 'sortImage',
					iconClass: 'icon-sortNew',
					show: (this.props.from != 'listing' && this.props.showSortImage && !selectedMedia.isVideo),
					info: 'Sort Image',
					onClick: (e) => {
						this.setState({ showSortItemSlider: true });
					}
				},{
					key: 'editImage',
					iconClass: 'icon-editItem',
					show: (!(isTemplate || isTempProd) && !selectedMedia.isVideo),
					info: 'Edit Image',
					onClick: () => {
						const url = imageUrls[this.state.selectedImageIndex].imgURL || imageUrls[this.state.selectedImageIndex].imageURL;
						if(url) {
							this.props.toggleEditOptions({
								show: true,
								cropperData: {
									src: url,
									selectedImageIndex: this.state.selectedImageIndex,
									listingProductData: this.props.from == 'listing' ? this.props.allProductsData : null,
									uploadProps: this.props?.uploadOptionProps?.isVariant || this.props.from == "listing" ? {
										...this.props.uploadOptionProps,
										deleteImage: this.deleteImageBusiness

									} : null,
									
								}
							});
						}
					}
				}

			];
		const moreOptionList = [
			...(this.state.selectedImageIndex != this.state.defaultImageIndex
				? [
					{
						label: 'Set as Default Image',
						show:
							this.state.selectedImageIndex !=
							this.state.defaultImageIndex,
						onClick: () => {
							this.setDefaultImage();
						}
					}
				]
				: []),
			{
				label: 'Delete Image',
				onClick: () => {
					this.deleteImage();
				}
			}
		];
		const showSaveButton =
			this.state.showSaveButton && !this.props.hideSaveButton && this.props.isMobile;
		const isEnrich = this.props?.isEnrich ? true : false;
		const slickProps = {
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			infinite: false,
			dots: this.props.showDots || false,
			afterChange: current => {
				this.setState({
					selectedImageIndex: current
				});

				if (this.thumbnailHolder) {
					const imageTile = document.querySelector(
						'.image-' + current
					);
					/**
					 * Getting the position of first thumbnail and incrementing the counter to 1.
					 * Once we get the position, there is no need to increment the counter,
					 * hence avoiding the if block below for the second afterChange event.
					 */
					if(this.sliderCounter <= 1) {
						this.firstImageTileLeftPosition = document.querySelector('.image-0')?.getBoundingClientRect()?.left || 0;
						this.sliderCounter = this.slickSlider + 1;
					}
					if (imageTile) {
						var bounding = imageTile.getBoundingClientRect();
						var inView =
							bounding.left >= 0 &&
							bounding.right <=
							(window.innerWidth ||
								document.documentElement.clientWidth);
						if (!inView) {
							let scrollLeft = 0;
							if (bounding.left < 0) {
								scrollLeft = bounding.left - 25;
							} else {
								scrollLeft = bounding.left - this.firstImageTileLeftPosition;
									// bounding.left +
									// imageTile.clientWidth -
									// this.thumbnailHolder.current.offsetWidth +
									// 25;
							}
							this.thumbnailHolder.current.scrollBy(scrollLeft, 0);
						}
					}
				}

				//imageTile.scrollIntoView({ behavior: "smooth" });
				/*  this.imageRow.animate([
                { // from
                  transform: 'translateX(20px)'
                },
                { // to
                  transform: 'translateX(-100px)'
                }
			  ], 200); */
				const loadedImages = this.getImagesToLoad(current);
				this.setState({ loadedImages: loadedImages });
			}
		};
		let noImgLabel = this.props.noImgLabel || 'Add a Product Photo';
		let inIFrame = (window.top != window.self) ? true : undefined;
		const showAddMediaDivs = !this.props.isTemplate && this.props.canUploadImage && (this.props.imageUrlArr.length < 40 || (!this.props.videoUrlIds.length && this.props.isSourceB2B));
		const errorFeedbackMarkup = errorMessage ? (
			<FormFeedBack
				variant='invalid'
				className='image-error-label'
			>
				{errorMessage}
			</FormFeedBack>
		) : null;
		return (
			<>
				<div
					className={`${styles['image-slider']} ${this.props.hasGlassFooter ? styles['ios-cls'] : ''} ${ imageUrls.length > 1 && this.props.showDots ? styles['slider-dots'] : ''} ${
						imageUrls.length > 1 ? styles['multiple-img-slider'] : ''
						} ${!imageUrls.length ? styles['no-image-holder'] : ''} ${
						isTemplate ? styles['template-slider'] : ''
						} ${errorIndex === 0 && errorMessage ? ' image-error' : ''} ${this.props.isSourceB2B ? 'b2b-view' : 'vendor-view'}`}
				>
					{imageUrls.length ? (
						<>
							<div className={styles['save-btn']}>
								{showSaveButton && !isEnrich ? (
									<MobileFilterRipple
										className={styles['image-slider-save']}
										clickHandler={this.props.closeSlider}
									>
										Save
									</MobileFilterRipple>
								) : null}
							</div>
							<div className={styles['floating-icons']}>
								{floatingBtnArr.map((cur, index) => {
									return cur.key == 'moreOption' &&
										cur.show ? (
											<MoreMenu
												key={cur.key}
												list={moreOptionList}
												menuClass={styles['menu-list']}
												parentClass={styles['icon-holder']}
											/>
										) : cur.show ? (
											<div
												key={cur.key}
												onClick={cur.onClick}
												className={styles['icon-holder']}
												tabIndex={0}
												role="button"
												aria-label={cur.info}
												onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); cur.onClick(e); } }}
											>
												<i
													className={
														cur.iconClass +
														' ' +
														styles['icon-style']
													}
												/>
												{!this.props.isMobile ? <DetailPopover
													info={cur.info}
													itemKey={cur.key}
												/> : null}
											</div>
										) : null;
								})}
							</div>
							<Slider
								ref={i => (this.slickSlider = i)}
								{...slickProps}
								className={`${styles['image-holder']} ${this.props.className}`}
							>
								{imageUrls.map((cur, index) => {
									const isImageLoaded = this.state.loadedImages.includes(index);
									return cur.isVideo ? (
										<VideoPlayer
											{...cur}
											playing={
												index ===
												this.state.selectedImageIndex
											}
											horizontal
											showStatusTag
										/>
									) : (
											<>
												{isImageLoaded && (
													<Image
														{...cur}
														previewImage={true}
														key={index}
														imgClass={styles['image-preview']}
														onClick={() => {
															this.props.onViewImageClick && this.props.onViewImageClick(index)
														}
														}
													/>
												)}
											</>
										)
								}
								)}
							</Slider>
							{(this.props.canUploadImage || imageUrls.length > 1) && !this.props.uploadSingleImage && (
								<div className={styles['image-row-wrapper']}>
									{(!this.props.isMobile || inIFrame) && <ScrollIndicators
										scrollContainerRef={this.thumbnailHolder}
										mediaLength={imageUrls.length}
									/>}
									<div
										//ref={i => (this.imageRow = i)}
										className={styles['image-row']}
										ref={this.thumbnailHolder}
										body-scroll-lock-ignore='true'
									>
										{imageUrls.length > 0 && imageUrls.map((cur, index) => {
											return (
												<div
													key={'image-' + index}
													onClick={() => this.onImageClick(index)}
													onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.onImageClick(index); }}
													tabIndex={0}
													role="button"
													aria-label={cur.isVideo ? `Video ${index + 1}` : `Image ${index + 1}`}
													className={`${
														styles['image-tile']
														} ${'image-' + index} ${
														this.state
															.selectedImageIndex ==
															index
															? styles['selected']
															: ''
														} ${
														this.state
															.defaultImageIndex ==
															index
															? styles['default']
															: ''
														}`}
												>
													{cur.isVideo ? (
														<VideoPlayer
															{...cur}
															showThumbnail
															showStatus
															sqSize='65%'
														/>
													) : (
															<Image
																{...cur}
																key={index}
															/>
														)}
													{!cur.isVideo && !this.state.dontShowPrimaryTag && <div
														className={
															styles['default-title']
														}
													>
														<span><i className={`${styles['primary-icon']} icon-starFill`}></i>PRIMARY</span>
													</div>}
												</div>
											);
										})}
										{(showAddMediaDivs && !this.props.isReadOnly) && <MultipleAddImageDiv
											{...this.props}
											isAddImageDiv
											errorIndex={errorIndex}
											errorMessage={errorMessage}
											hideAddVideo={this.props.hideAddVideo}
											onChange={this.onImageAdd}
											className={'image-upload-view-image'}
											openImageOptions={() => { this.setState({ showUploadSlider: true }); }}
										/>}
									</div>
								</div>
							)}
						</>
					) : (isTemplate || this.props.session.isReadOnly) ? (
						<div className={styles['no-image']}>
							<img
								src='https://image1.jdomni.in/jdomni_email/NOIMAGE_2002211157.png'
								style={{ height: 90 }}
							/>
						</div>
					) : (
								<div
									className={
										styles['add-new-image'] +
										' ' +
										this.props.rippleClass
									}
									{...this.props.rippleHandler}
									onClick={(e) => {
										this.useBottomPostion = true;
										this.checkForOptions(e)
									}}
									tabIndex={0}
									role="button"
									aria-label={noImgLabel}
									onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.useBottomPostion = true; this.checkForOptions(e); } }}
								>
									{this.props.renderRipple()}
									<i
										className={`icon-AddNewImage ${styles['add-icon']}`}
									/>
									<div className={styles['add-title']}>
										{noImgLabel}
									</div>
									<div className={this.props.noImgLabel === 'Add a Product  Photo' ? `${styles['recomendedtext']} ${styles['marginadd']}` : styles['recomendedtext'] }>
										{!this.props.session.viaOmni ? 
										<>
											<div>Recommended Size:  <span className={styles['recomendedbold']}>1000 px</span> X <span className={styles['recomendedbold']}>1000 px</span></div>
											<div>Minimum Image Size:  <span className={styles['recomendedbold']}>620 px</span> X  <span className={styles['recomendedbold']}>620 px</span></div>
										</> : null}
										{this.props.categoryType != 'service' && !this.props.session.viaOmni ? <div>Primary Image should have a White Background</div> : null}
									</div>
								</div>
							)}
					<FileSelector
						onChange={e => { this.onFileUpload(e, this.props) }}
						ref={i => (this.fileSelector = i)}
					/>
					{errorIndex ? errorFeedbackMarkup : null}
				</div>
				{!errorIndex ? errorFeedbackMarkup : null}
				{this.state.showPrimaryModal && <ActionDialog
					ref={this.actionModalRef}
					{...this.state.modalOptions}
				></ActionDialog>}
				{this.state.showUploadSlider && (<UploadImageOptions
					onHidden={() => this.setState({ showUploadSlider: false })}
					showToastMessage={this.props.showToastMessage}
					imgUploadUrl={this.props.imgUploadUrl}
					onClickGallery={() => {
						const allowMultipleImages = this.props.allowMultipleImages === undefined ? true : this.props.allowMultipleImages;
						this.fileSelector.triggerClick(allowMultipleImages);
						this.setState({ showUploadSlider: false });
					}}
					type={this.props.type}
					productId={this.props.productId}
					isDummyProductRow = {this.props.isDummyProductRow}
					updateProductImage={(data) => {
						this.setState({ showUploadSlider: false });
						this.props.updateProductImage && this.props.updateProductImage(data);
					}}
				/>)}
				{this.state.showSortItemSlider ?
					<SortItemSlider
						items={this.state.imageUrlList}
						moveOption={this.moveOption}
						onSave ={this.updateImagePosition}
						onHidden={()=> this.setState({showSortItemSlider : false})}
					/>
					: null
				}
			</>
		);
	}
}
const MultipleAddImageDiv = (props) => {
	let addImageDivCount = getAddImageDivCount({
		images: props.imageUrlArr.length,
		videos: props.videoUrlIds.length,
		isSourceB2B: props.isSourceB2B,
		isAddEditPage: props.isAddEditPage
	});
	let markup = [];
	markup = [...Array(addImageDivCount)].map((_, addIndex) => {
		let isErrorDiv = props.errorIndex === 1 && props.errorMessage && !addIndex;
		return (
			<ImageViewUpload
				{...props}
				key={addIndex + '__'}
				showError={isErrorDiv}
				imageListIndex={props.imageUrlArr.length + addIndex}
			/>
		)
	})
	if ((!props.videoUrlIds.length && props.isSourceB2B) && !props.hideAddVideo) {
		markup.push(
			<AddVideoDiv
				key={'addvideodiv'}
				{...props}
			/>
		)
	}
	return markup
}

const getVideoById = (id, videos = {}) => {
	let videoObj;
	if (videos[id]) {
		videoObj = videos[id]
	} else {
		id = Object.keys(videos).find(key => videos[key].imgIndex === id)
		videoObj = videos[id]
	}
	return videoObj
}


export const mapVideosToProps = (parent, {
	videoLibrary
}, props) => {
	const {
		productData
	} = parent;
	const {
		videos
	} = videoLibrary;
	parent.videoUrlArr = []
	if (!productData.videoUrlIds || !productData.videoUrlIds.length) {
		return
	}
	parent.videoUrlIds = productData.videoUrlIds;
	productData.videoUrlIds.forEach((curId) => {
		let curVideoData = getVideoById(curId, videos);
		if (curVideoData) {
			curVideoData = { ...curVideoData };
			curVideoData.videoId = curId;
			parent.videoUrlArr.push(curVideoData)
		}
	})
}

const mapStateToProps = (state = {}, props) => {
	const newProps = {
		...props,
		videoUrlArr: [],
		videoUrlIds: []
	}
	newProps.isSourceB2B = false;
	let prodData = state.products.allProducts[props.productId] || {};
	if(state.products.editProduct?.imageUrlArr?.length || (props.isAddEditPage && props.productId !== 'ADD_PRODUCT')){
		prodData = state.products.editProduct;
	}
	if (typeof props.imageUrlArr === 'undefined') {//for B2B source
		newProps.productData = {...prodData};
		newProps.isTemplate = newProps.productData.isTemplate && newProps.productData?.showUpload !== 1;
		newProps.imageUrlArr = (newProps.productData.imageUrlArr && [...newProps.productData.imageUrlArr]) || [];
		mapVideosToProps(newProps, state, props);
	}else if(props.videoUrlArr || props.videoUrlIds){
		if(props.videoUrlArr) {
			newProps.videoUrlArr = props.videoUrlArr;
			newProps.videoUrlIds = props.videoUrlIds || [];
		} else {
			newProps.productData = {
				videoUrlIds: props.videoUrlIds,
			}
			mapVideosToProps(newProps, state, props);
		}
	}
	// if(props.videoUrlIds?.length){
	// 	newProps.videoUrlIds = props.videoUrlIds;
	// }
	newProps.session = newProps.session || state.session;
	if (newProps.session) {
		newProps.isSourceB2B = newProps.session.source === 'b2b'
	}
	newProps.showMax = state.products?.editProduct?.showMax;
	newProps.hasGlassFooter = state.session?.hasGlassFooter || props?.hasGlassFooter;
	return newProps;
};
export default withRipple(
	connect(mapStateToProps, {
		toggleUploadOptions, updateEditProductDetail, showLibraryToastMessage: toastMessageActions.showMessage,toggleEditOptions
	})(ViewImage)
);
